"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=spectral.js.map